import Qty from 'js-quantities';

export function GetStatusColor(status: string) {
  switch (status) {
    case 'Created':
      return 'Light Gray';
      break;
    case 'Configured':
      return 'Light Gray';
      break;
    case 'Private':
      return 'Dark Gray';
      break;
    case 'Installing':
      return 'Light Blue';
      break;
    case 'Active':
      return 'Green';
      break;
    case 'Public':
      return 'Green';
      break;
    case 'PendingLicense':
      return 'Light Red';
      break;
    case 'Deleted':
      return 'Light Red';
      break;
    case 'Retired':
      return 'Light Red';
      break;
    default:
      return 'Light Gray';
      break;
  }
}

export function GetLicenseColor(license: string) {
  switch (license) {
    case 'Ultimate':
      return 'Ultimate Orange';
      break;
    case 'Cruise':
      return 'Dark Gray';
      break;
    case 'Comfort':
      return 'Light Gray';
      break;
    case 'Comfort Plus':
      return 'Light Gray';
      break;
    case 'Dynamic':
      return 'Light Gray';
      break;
    case 'Dynamic Plus':
      return 'Light Gray';
      break;
    case '':
      return 'Light Red';
      break;
  }
}

export function GetStatusText(status: string) {
  switch (status) {
    case 'Created':
      return 'To be installed';
      break;
    case 'Configured':
      return 'To be installed';
      break;
    case 'Installing':
      return 'Installing';
      break;
    case 'Active':
      return 'Active';
      break;
    case 'PendingLicense':
      return 'Pending license';
      break;
    case 'Retired':
      return 'Retired';
      break;
    case 'Deleted':
      return 'Deleted';
      break;
    default:
      return '';
  }
}

export const comparisonColor = (color: number) => {
  if (color > 0) {
    return 'text-success-100';
  } else if (color < 0) {
    return 'text-error-100';
  } else return 'text-gray-20';
};

export const comparisonPositive = (value: number) => {
  if (value > 0) {
    return '+';
  } else return '';
};

export function ConversionMeter(input: number, isMetric: boolean): number;
export function ConversionMeter(input: number, isMetric: boolean, withUnit: true): string;
export function ConversionMeter(input: number, isMetric: boolean, withUnit?: boolean): number | string;
export function ConversionMeter(input: number, isMetric: boolean, withUnit?: boolean) {
  const fromUnit = !isMetric ? 'meter' : 'foot';
  const toUnit = fromUnit === 'meter' ? 'foot' : 'meter';
  const displayUnit = isMetric ? 'meter' : 'feet';

  if (!input) {
    return withUnit ? `0 ${displayUnit}` : 0;
  }

  let convertedValue: number;
  if (isMetric) {
    convertedValue = Number(input);
  } else {
    const qtyString = input + fromUnit;
    const qty = new Qty(qtyString);
    const resultNum = qty.to(toUnit);
    const { scalar } = resultNum;
    convertedValue = Math.round(scalar);
  }

  return withUnit ? `${convertedValue} ${displayUnit}` : convertedValue;
}

export function ConversionSpeed(input: number, isKnots: boolean): number;
export function ConversionSpeed(input: number, isKnots: boolean, withUnit: true): string;
export function ConversionSpeed(input: number, isKnots: boolean, withUnit?: boolean): number | string;
export function ConversionSpeed(input: number, isKnots: boolean, withUnit?: boolean) {
  const fromUnit = !isKnots ? 'kn' : 'mph';
  const toUnit = fromUnit === 'kn' ? 'mph' : 'kn';

  if (!input) {
    const displayUnit = isKnots ? 'kn' : 'mph';
    return withUnit ? `0 ${displayUnit}` : 0;
  }
  let convertedValue: number;
  if (isKnots) {
    convertedValue = Number(input);
  } else {
    const qtyString = input + fromUnit;
    const qty = new Qty(qtyString);
    const resultNum = qty.to(toUnit);
    const { scalar } = resultNum;
    convertedValue = Math.round(scalar);
  }

  const displayUnit = isKnots ? 'kn' : 'mph';
  return withUnit ? `${convertedValue} ${displayUnit}` : convertedValue;
}

export function ConversionKilogram(input: number, isMetric: boolean): number;
export function ConversionKilogram(input: number, isMetric: boolean, withUnit: true): string;
export function ConversionKilogram(input: number, isMetric: boolean, withUnit?: boolean): number | string;
export function ConversionKilogram(input: number, isMetric: boolean, withUnit?: boolean) {
  const fromUnit = !isMetric ? 'kg' : 'lbs';
  const toUnit = fromUnit === 'kg' ? 'lbs' : 'kg';
  const displayUnit = isMetric ? 'kg' : 'lbs';

  if (!input) {
    return withUnit ? `0 ${displayUnit}` : 0;
  }

  let convertedValue: number;
  if (isMetric) {
    convertedValue = Number(input);
  } else {
    const qtyString = input + fromUnit;
    const qty = new Qty(qtyString);
    const resultNum = qty.to(toUnit);
    const { scalar } = resultNum;
    convertedValue = Math.round(scalar);
  }

  return withUnit ? `${convertedValue} ${displayUnit}` : convertedValue;
}

export const CalculateDaysBetweenDates = (startDate: Date, endDate: Date) => {
  const differenceInTime = new Date(endDate).getTime() - new Date(startDate).getTime();
  const differenceInDays = differenceInTime / (1000 * 3600 * 24);
  return Math.ceil(differenceInDays);
};

export const CalculateMinutesToDays = (minutes: number) => {
  return Math.ceil(minutes / 1440);
};
